import './index.scss';

import type { MessageArgsProps } from 'ant-design-vue';
import { message } from 'ant-design-vue';
import type { VNode } from 'vue';
import { h } from 'vue';
import type { JSX } from 'vue/jsx-runtime';

import ErrorIcon from './assets/error_icon.png';
import SuccessIcon from './assets/success_icon.png';
import WarningIcon from './assets/warning_icon.png';

// 目前andt中的，后面按需实现
declare type VNodeChildAtom =
  | VNode
  | string
  | number
  | boolean
  | null
  | undefined
  | void;
export type VueNode = VNodeChildAtom | VNodeChildAtom[] | JSX.Element;
export type AntdMessageOptions = MessageArgsProps | VueNode;
export type NoticeType = 'info' | 'success' | 'error' | 'warn' | 'loading';

// 是否是使用message.success('xxx')的方式
const isOnlyContent = (options: AntdMessageOptions) => {
  return !(
    Object.prototype.toString.call(options) === '[object Object]' &&
    !!(options as MessageArgsProps).content
  );
};

const createIcon = (type: NoticeType) => {
  const icons: any = {
    success: SuccessIcon,
    warn: WarningIcon,
    error: ErrorIcon
  };
  return h('img', { src: icons[type] });
};

let lastMsg: {
  type?: string;
  content?: string;
} = {};
const cacheMsg = (type: NoticeType, msg: string) => {
  lastMsg = {
    type,
    content: msg
  };
  // 2s内相同消息不重复弹
  setTimeout(() => {
    lastMsg = {};
  }, 2000);
};
const notice = (type: NoticeType, options: AntdMessageOptions) => {
  // @ts-ignore
  const msgContent = options?.content ?? options;
  // 处理多条相同的msg提示过多的问题
  if (type == lastMsg.type && msgContent == lastMsg.content) {
    return;
  }
  cacheMsg(type, msgContent);

  const customOption = {
    class: 'custom',
    duration: (options as MessageArgsProps).duration ?? 3,
    icon: createIcon(type)
  };

  // 支持下message.success('xxx')的用法
  if (isOnlyContent(options)) {
    message[type]({
      ...customOption,
      content: options
    } as AntdMessageOptions);
  } else {
    message[type]({
      ...customOption,
      ...(options as MessageArgsProps)
    });
  }
};

export default {
  success: (options: AntdMessageOptions) => notice('success', options),
  warn: (options: AntdMessageOptions) => notice('warn', options),
  error: (options: AntdMessageOptions) => notice('error', options)
};
